<template>
  <template v-if="isInit">
    <table class="tb-row">
      <colgroup>
        <col style="width:30%;" />
        <col style="width:auto;" />
      </colgroup>
      <tbody>
      <tr>
        <th>시설명</th>
        <td class="last">
          <input type="text" style="width: 100%;"
                 maxlength="15"
                 v-model="fcltyNm"/>
        </td>
      </tr>
      <tr>
        <th>사업자등록번호</th>
        <td class="last">
          <number-ip :data="bzno1"
                     :width="'80px'"
                     :maxlength="3"
                     @input="ipBzno1_input"/> -
          <number-ip :data="bzno2"
                     :width="'60px'"
                     :maxlength="2"
                     @input="ipBzno2_input"/> -
          <number-ip :data="bzno3"
                     :width="'120px'"
                     :maxlength="5"
                     @input="ipBzno3_input"/>
        </td>
      </tr>
      <tr>
        <th>대표자명</th>
        <td class="last">
          <input type="text" style="width: 100%;"
                 maxlength="15"
                 v-model="rpstvNm"/>
        </td>
      </tr>
      <tr>
        <th>사업자등록증</th>
        <td class="last">
          {{ bzlcFile.orgnFlnm }}
          <single-file-upload
                  :se="'tmp'"
                  :accepts="'png,jpg,pdf'"
                  :is-resize-img="true"
                  @change="bzlcFile_change"/>
        </td>
      </tr>
      </tbody>
    </table>
    <div class="info-txt-bottom">
      <p class="info1">시설기본정보 변경은 사업자등록증 확인 후 변경처리되며, 1~2일 정도 소요됩니다.</p>
    </div>
    <div class="layer-btn">
      <btn :txt="'취소'"
           :color="'white'"
           @click="btnCancl_click"/>
      <btn :txt="'요청'"
           :color="'purple'"
           @click="btnRqt_click"/>
    </div>
  </template>
</template>

<script setup>
import {computed, defineEmits, defineProps, onMounted, ref} from "vue";

import {getStore, getUtils} from "@/utils/import";
const {$alert, $axios, $cmmn} = getUtils();
const {$mber, $loading} = getStore();

const props = defineProps({
  fcltySn: {
    type: Number,
    required: true
  }
})

const fcltyNm = ref('');
const rpstvNm = ref('');
const bzno1 = ref('');
const bzno2 = ref('');
const bzno3 = ref('');
const bzno = computed(() => bzno1.value + bzno2.value + bzno3.value);
const bzlcFile = ref({});

const bzlcFile_change = async (fileInfo) => {
  bzlcFile.value = JSON.parse(JSON.stringify(fileInfo));
}

const ipBzno1_input = (data) => {
  bzno1.value = data;
}

const ipBzno2_input = (data) => {
  bzno2.value = data;
}

const ipBzno3_input = (data) => {
  bzno3.value = data;
}

const valid = () => {
  let isValid = true;
  let msg = '';

  if (isValid && !fcltyNm.value) {
    isValid = false;
    msg = '시설명을 입력해주세요.';
  }

  if (isValid && bzno.value.length != 10) {
    isValid = false;
    msg = '사업자등록번호를 입력해주세요.';
  }

  if (isValid && !rpstvNm.value) {
    isValid = false;
    msg = '대표자명을 입력해주세요.';
  }

  if (isValid && !bzlcFile.value.flnm) {
    isValid = false;
    msg = '사업자등록증 파일을 첨부해주세요.';
  }

  return {isValid, msg};
}

const btnRqt_click = async () => {
  try {
    $loading.on();
    const {isValid, msg} = valid();

    if (!isValid) {
      await $alert(msg);
      return false;
    }

    const rqtParams = {
      fcltySn: props.fcltySn,
      mberSn: $mber.mberSn,
      fcltyNm: fcltyNm.value,
      rpstvNm: rpstvNm.value,
      bzno: bzno.value,
      bzlcFile: bzlcFile.value
    }

    await rqtFcltyBsInfo(rqtParams);
  } catch (e) {
    await $cmmn.errorMsg(e);
  } finally {
    $loading.off();
  }
}

const rqtFcltyBsInfo = async ({fcltySn, mberSn, fcltyNm, rpstvNm, bzno, bzlcFile}) => {
  const {data} = await $axios.post('/api/fclty/bs-info', {fcltySn, mberSn, fcltyNm, rpstvNm, bzno, bzlcFile});
  if (data == 0) {
    await $alert('오류가 발생하였습니다. 다시 시도해주세요.');
    return false;
  }

  await $alert('시설기본정보 변경 요청이 완료되었습니다.');
  emits('rqt-compt');
  close();
}

const emits = defineEmits(['close', 'rqt-compt']);
const btnCancl_click = () => {
  close();
}

const close = () => {
  emits('close');
}

const getFcltyByFcltySn = async () => {
  const data = await $cmmn.fclty.getFcltyByFcltySn(props.fcltySn);
  fcltyNm.value = data.fcltyNm;
  rpstvNm.value = data.rpstvNm;

  const bzno = data.bzno;
  bzno1.value = bzno.substring(0, 3);
  bzno2.value = bzno.substring(3, 5);
  bzno3.value = bzno.substring(5, 10);
}

const isInit = ref(false);
onMounted(async () => {
  try {
    $loading.on();

    await getFcltyByFcltySn();
    isInit.value = true;
  } catch (e) {
    await $cmmn.errorMsg(e);
  } finally {
    $loading.off();
  }
})
</script>

<style scoped>

</style>
